module.exports = __webpack_public_path__ + "img/20190821144702QQ截图20190821130524.48a8481f.png";